import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import * as generic from '../../../components/Generico';
import { CatalogoService } from '../../../service/CatalogoService';
import { JuridicaService } from '../../../service/JuridicaService';
import { InputComponent } from '../../../components/InputComponent';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { JuridicaGeneral } from '../../../models/ficha/JuridicaGeneral';
import { InputActividadEconomica } from '../../../components/ui/Formularios/InputActividadEconomica';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';

export const DatosGenerales = ({ toast, catalogos, next, id, nuevoAccionista, permss, soloLectura }) => {

    const esTipoEspecial = ['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa);
    const omodel = new JuridicaGeneral({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue } = useForm({ defaultValues, mode: 'onTouched' });
    const juridicaSrv = new JuridicaService();
    const catalogoSrv = new CatalogoService();
    const [ecuador, setEcuador] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const [ecuadorDG, setEcuadorDG] = useState(false);
    const [ciudadesDG, setCiudadesDG] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [siApartado, setSiApartado] = useState(false);
    const [totalAnexos, setTotalAnexos] = useState(0);
    const [deshabilitarNuevo, setDeshabilitarNuevo] = useState(false);
    const { inDrop, inText, inCalendar, inArea } = InputComponent({ omodel, errors, control, permss, id, soloLectura });

    useEffect(() => {
        if (id != null) {
            editarFicha();
        } else {
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [id]);

    const editarFicha = () => {
        setIsLoading(true);
        juridicaSrv.consultarJuridica(id ?? 0, 'seccion1').then(res => {
            const cats = catalogos;
            if (!res.data.juridica) {
                setIsLoading(false);
                return;
            }
            let _juridica = res.data.juridica;
            _juridica.fecha = generic.stringToDate(_juridica.fecha);
            _juridica.fecha_inicio_actividad = generic.stringToDate(_juridica.fecha_inicio_actividad);

            setTotalAnexos(res.data.totalAnexos ?? 0);

            if (res.data.ciudades !== undefined) {
                setCiudades(res.data.ciudades);
            }
            if (res.data.ciudad_datos_generales !== undefined) {
                setCiudadesDG(res.data.ciudad_datos_generales);
            }

            setDeshabilitarNuevo(res.data.totalTercero > 0 || res.data.totalForma > 0);

            setEcuador(JSON.stringify(_juridica.pais) === JSON.stringify(cats.ecuador));
            setEcuadorDG(JSON.stringify(_juridica.pais_datos_generales) === JSON.stringify(cats.ecuador));
            setSiApartado(_juridica.nacionalidad?.cat_id !== cats?.ecuador_nac?.cat_id);

            reset(generic.renewValues(_juridica, omodel.model));
        }).finally(() => setIsLoading(false));
    };

    const onSubmit = (data) => {
        setIsSaving(true);
        data.fecha = generic.dateToString(data.fecha);
        data.fecha_inicio_actividad = generic.dateToString(data.fecha_inicio_actividad);
        data.ec = catalogos.ecuador.cat_id;
        data.ecDG = catalogos.ecuador.cat_id;
        data.ecn = catalogos?.ecuador_nac;
        data.seccion = 'seccion1';
        data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa;

        const request = !id ? juridicaSrv.newJuridica(data) : juridicaSrv.editarJuridica({ ...data, id });
        request.then(res => {
            generic.funcSuccess(res, toast);
            if (!id) {
                nuevoAccionista({ id: res.data.id, nemonico: res.data.nemonico });
            }
            next();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const onChangePais = (e) => {
        setEcuador(JSON.stringify(e.value) === JSON.stringify(catalogos.ecuador));
        setValue('provincia', null);
        setValue('ciudad', null);
        setCiudades([]);
    }

    const onChangeProvincia = (e) => {
        setValue('ciudad', null);
        if (!e?.value) {
            setCiudades([]);
            return;
        }
        catalogoSrv.getCatalogosId(e.value.cat_id).then(res => {
            setCiudades(res.data);
        });
    }

    const onChangePaisDG = (e) => {
        setEcuadorDG(JSON.stringify(e.value) === JSON.stringify(catalogos.ecuador));
        setValue('provincia_datos_generales', null);
        setValue('ciudad_datos_generales', null);
        setCiudadesDG([]);
    }

    const onChangeProvinciaDG = (e) => {
        setValue('ciudad_datos_generales', null);
        if (!e?.value) {
            setCiudadesDG([]);
            return;
        }
        catalogoSrv.getCatalogosId(e.value.cat_id).then(res => {
            setCiudadesDG(res.data);
        });
    }

    const reglaValidacion = (val) => {
        return generic.validarIdentificacionEcuador(val, 'IDEN_RUC') || `RUC incorrecto`;
    };

    const onChangeNacionalidad = (e) => {
        setSiApartado(e.value?.cat_id !== catalogos?.ecuador_nac?.cat_id);
        setValue('codigo_postal', '');
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form id="datosGeneralesForm" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
            <Panel header={generic.renderPanelHeader('A', 'DATOS DE LA SOLICITUD', 'pi pi-cog')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {omodel.model.tipo_juridico.table && inDrop('tipo_juridico', catalogos?.tipoPersonaJuridica, { lab: omodel.optionLabel }, 4)}
                    {inCalendar('fecha', {}, omodel.model.tipo_juridico.table ? 4 : 6)}
                    {inDrop('pais', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais, val: false }, omodel.model.tipo_juridico.table ? 4 : 6)}
                    {ecuador ? (
                        <>
                            {inDrop('provincia', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia, val: false }, 4)}
                            {inDrop('ciudad', ciudades, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('canton', { icon: 'pi pi-map-marker' }, 8)
                    )}
                    {inDrop('nuevo_accionista', generic.estadosSiNo, { lab: omodel.optionLabel, ne: deshabilitarNuevo ? 'disabled' : '' }, 4)}
                    {omodel.model.compania.table && !esTipoEspecial && inText('compania', { icon: 'pi pi-building' }, 4)}
                    {omodel.model.grupo_empresarial.table && inDrop('grupo_empresarial', generic.estadosSiNo, { lab: omodel.optionLabel }, 4)}
                    {inDrop('tipo_formulario', catalogos?.tipoFormulario, { lab: omodel.optionLabel }, 4)}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('1', 'DATOS GENERALES', 'pi pi-id-card')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inText('razon_social', { icon: 'pi pi-briefcase' }, 4)}
                    {inText('identificacion', { validate: reglaValidacion, icon: 'pi pi-id-card' }, 4)}
                    {inDrop('nacionalidad', catalogos?.nacionalidad, { lab: omodel.optionLabel, chn: onChangeNacionalidad, ne: totalAnexos > 0 }, 4)}
                    {inCalendar('fecha_inicio_actividad', {}, 4)}
                    <InputActividadEconomica name="actividad_economica" control={control} modelDef={omodel.model['actividad_economica']} disabled={soloLectura} col={8} />
                    {inDrop('pais_datos_generales', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePaisDG, val: false }, 4)}
                    {ecuadorDG ? (
                        <>
                            {inDrop('provincia_datos_generales', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvinciaDG, val: false }, 4)}
                            {inDrop('ciudad_datos_generales', ciudadesDG, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('canton_datos_generales', { icon: 'pi pi-map-marker' }, 8)
                    )}
                    {inArea('direccion_oficina', 3, 220, 12)}
                    {siApartado && inText('codigo_postal', { icon: 'pi pi-envelope' }, 4)}
                    {inText('telefono_empresa', { icon: 'pi pi-phone' }, siApartado ? 4 : 6)}
                    {inText('pagina_web_email', { icon: 'pi pi-globe' }, siApartado ? 4 : 6)}
                </div>
            </Panel>

            <BottomActionBar fromId="datosGeneralesForm" onNext={next} loading={isSaving} isReadOnly={soloLectura} />
        </form>
    );
}
